package io.horion.cv.pages.cv

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.components.Footer
import io.horion.cv.components.Topbar
import io.horion.cv.components.widgets.CustomDropdown
import io.horion.cv.models.OrientationData
import io.horion.cv.styles.CreateButtonStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.POPPINS
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@OptIn(DelicateApi::class)
@Page("/creer_un_cv")
@Composable
fun OrientationCvPage() {

    val ctx        = rememberPageContext()
    val breakpoint = rememberBreakpoint()
    val isMobile   = breakpoint <= Breakpoint.MD

    val colorMode by ColorMode.currentState
    val isDark    = colorMode.isDark

    val pageBg    = if (isDark) Colors.DarkBG  else Colors.White
    val textColor = if (isDark) Colors.White   else Colors.DarkBlue

    var domaine    by remember { mutableStateOf(OrientationData.domaines.first()) }
    var poste      by remember { mutableStateOf(OrientationData.postes.first()) }
    var experience by remember { mutableStateOf(OrientationData.experiences.first()) }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(pageBg)
            .styleModifier {
                property("min-height", "100vh")
                property("transition", "background-color 300ms ease")
            },
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Topbar()

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .position(Position.Relative),
            contentAlignment = Alignment.BottomCenter
        ) {
            Image(
                src = "orientation-banniere.jpg",
                description = "bannière image",
                modifier = Modifier
                    .fillMaxWidth()
                    .styleModifier {
                        property("display", "block")
                        property("height",  "auto")
                    }
            )

            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(if (isMobile) 160.px else 300.px)
                    .position(Position.Absolute)
                    .styleModifier {
                        property("bottom", "0")
                        property("left", "0")
                        property(
                            "background",
                            "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.92) 100%)"
                        )
                        property("pointer-events", "none")
                    }
            )

            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .position(Position.Absolute)
                    .padding(
                        bottom    = if (isMobile) 20.px else 40.px,
                        leftRight = if (isMobile) 20.px else 40.px
                    )
                    .styleModifier { property("bottom", "0") },
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                SpanText(
                    "Créons ensemble un CV\nqui va vraiment vous être utile",
                    modifier = Modifier
                        .color(textColor)
                        .fontSize(if (isMobile) 22.px else 45.px)
                        .fontFamily(POPPINS)
                        .fontWeight(FontWeight.SemiBold)
                        .textAlign(TextAlign.Center)
                        .whiteSpace(WhiteSpace.PreWrap)
                        .lineHeight(1.2)
                        .margin(bottom = if (isDark) 10.px else 30.px)
                )
                SpanText(
                    "Ne créez pas juste un cv, mais créez un cv UTILE,\nun cv adapté à l'emploi qui vous intéresse.",
                    modifier = Modifier
                        .color(if (isDark) Colors.DarkGray else Colors.borders)
                        .fontSize(if (isMobile) 12.px else 16.px)
                        .fontFamily(POPPINS)
                        .fontWeight(FontWeight.Normal)
                        .whiteSpace(WhiteSpace.PreWrap)
                )
            }
        }

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(
                    top       = if (isMobile) 30.px else 44.px,
                    bottom    = if (isMobile) 50.px else 85.px,
                    leftRight = if (isMobile) 24.px else 200.px
                ),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            CustomDropdown(
                label = "Quel est votre domaine d'activité ?",
                options = OrientationData.domaines,
                selected = domaine,
                isMobile = isMobile,
                onSelect = { domaine = it }
            )

            CustomDropdown(
                label = "A quel poste voulez-vous candidater ?",
                options = OrientationData.postes,
                selected = poste,
                isMobile = isMobile,
                onSelect = { poste = it }
            )

            CustomDropdown(
                label = "Combien d'années d'expérience avez-vous ?",
                options = OrientationData.experiences,
                selected = experience,
                isMobile = isMobile,
                onSelect = { experience = it }
            )

            Box(modifier = Modifier.height(if (isMobile) 16.px else 28.px))

            StartButton(
                isMobile = isMobile,
                onClick = {
                    ctx.router.navigateTo(
                        "/choose-cv"
//                                "?domaine=${domaine}" +
//                                "&poste=${poste}" +
//                                "&experience=${experience}"
                    )
                }
            )
        }

        Footer()
    }
}

@Composable
fun StartButton(
    text     : String = "Commencer",
    isMobile : Boolean = false,
    onClick  : () -> Unit
) {
    val colorMode by ColorMode.currentState
    val isDark    = colorMode.isDark
    val textColor = if (isDark) Colors.yellow else Colors.White

    Button(
        onClick = { onClick() },
        modifier = CreateButtonStyle.toModifier()
            .fontFamily(POPPINS)
            .borderRadius(50.px)
            .fontSize(if (isMobile) 16.px else 25.px)
            .fontWeight(FontWeight.SemiBold)
            .color(textColor)
            .padding(
                topBottom  = if (isMobile) 10.px else 30.px,
                leftRight  = if (isMobile) 24.px else 50.px
            )
            .styleModifier {
                property("display",          "flex")
                property("align-items",      "center")
                property("justify-content",  "center")
                property("transition",       "color 300ms ease, border-color 300ms ease")
            }
    ) {
        Text(text)
    }
}